import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import Carousel from '../../../commonComponents/carousel/Carousel';
import ShopProductItem from './ShopProductItem';
import ProductProp from '../propTypes/productVariationsProp';
import ProductPlaceholder from './ShopProductPlaceholder';
import ServerSideCarousel from '../../../commonComponents/carousel/ServerSideCarousel';

function ShopHighlightCarousel({ productList }) {
  const fetchUrl = '/shop/product/highlights';

  return (
    <div className="m-portlet m-portlet--rounded m-portlet--rounded-force m--margin-top-10 m--margin-bottom-10 shop-carousel-container">
      <div className="m-portlet__body m--padding-top-5 m--padding-bottom-20 shop-carousel">
        <div className="row">
          <Carousel>
            <ServerSideCarousel
              id="highlight-products-carousel"
              fetchUrl={fetchUrl}
              defaultFetchError="error_fetchCourses"
              placeholder={<ProductPlaceholder />}
              items={productList}
            >
              {items =>
                items.map(p => (
                  <ShopProductItem compactDisplay key={p._id} product={p} />
                ))
              }
            </ServerSideCarousel>
          </Carousel>
        </div>
      </div>
    </div>
  );
}

ShopHighlightCarousel.propTypes = {
  productList: PropTypes.arrayOf(PropTypes.shape(ProductProp.propType)),
};

ShopHighlightCarousel.defaultProps = {
  productList: [],
};

export default translate(ShopHighlightCarousel);
